export default {"src":"/_next/static/media/icone-potential.9533f1e1.svg","height":18,"width":32,"blurWidth":0,"blurHeight":0};